<!-- Header -->
<h1 mat-dialog-title>
  {{ 'filter' | translate: 'plural' }}
  <span class="button-group">
    <button mat-button tabindex="-1" (click)="check('all')">{{ 'selectall' | translate }}</button>
    <button mat-button tabindex="-1" (click)="check('none')">{{ 'selectNone' | translate }}</button>
    <button mat-button tabindex="-1" (click)="check('toggle')">{{ 'toggle' | translate }}</button>
  </span>
</h1>

<!-- Content -->
<div mat-dialog-content>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">

    <!-- Tree node -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-icon-button disabled></button>
      <mat-checkbox 
        [checked]="descendantsAllSelected(node)"
        (change)="nodeSelectionToggle(node)">
        {{ node.label }}
      </mat-checkbox>
    </mat-tree-node>

    <!-- Tree node with children -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChildren" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle tabindex="-1">
        <mat-icon>
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <mat-checkbox
        [checked]="descendantsAllSelected(node)"
        [indeterminate]="descendantsPartiallySelected(node)"
        (change)="nodeSelectionToggle(node)">
        {{ node.label }}
      </mat-checkbox>
    </mat-tree-node>

  </mat-tree>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">

  <button mat-button tabindex="-1" (click)="dialogRef.close()">
    {{ 'cancel' | translate }}
  </button>
  
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'">
    {{ 'apply' | translate }}
  </button>

</div>
